<template>
  <section>
    <!-- Header -->
    <leftMenu />

    <create-new-chat :callCheckList="callCheckList" :actionOpenNewChat.sync="openNewChat"/>

    <div id="mainContent" class="chat-content">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 pg-title">
          <h1 class="certa">Conversas</h1>
        </div>

        <loading-page v-if="loading" />

        <div v-if="!loading" class="col-xs-12 col-sm-12 col-md-12 padding-null offset-top-20">
          <div class="col-xs-12 col-sm-12 col-md-12">
            <button v-if="haveAccess" v-on:click="openCreateChat()" class="create-new-chat certa" type="submit">Nova Conversa</button>
          </div>

          <div v-if="listChat.length" class="col-xs-12 col-sm-12 col-md-12 offset-top-30">
            <p class="default-text right">
              <i v-on:click="openChat(chatSelected.data, chatSelected.index)" v-tooltip.top-center="'Para atualizar a conversa, clique aqui'" class="fa fa-refresh refresh cursor" aria-hidden="true"></i>
              Última atualização realizada as {{dataAtt | formatHours}}<span></span></p>
          </div>
          <div v-if="listChat.length" class="col-xs-12 col-sm-12 col-md-12 padding-null default-box offset-top-4">

            <!-- List Chat -->
            <div class="col-xs-12 col-sm-4 col-md-3 left-list-chat custom-scrollbar">
              <div v-on:click="openChat(c, index)" v-for="(c, index)  in listChat" class="col-xs-12 col-sm-12 col-md-12 user-chat" v-bind:class="{'user-chat-active': chatSelected.index === index}">
                <div class="user-photo">
                  <img v-if="c.photo" v-bind:src="c.photo" class="img-responsive img-circle" alt="user">
                  <img v-else src="../../../../assets/img/user-default.png" class="img-responsive" alt="user">
                </div>

                <div class="user-info" v-bind:class="{'is-unread': !c.isread}">
                  <p style="position: relative" v-bind:title="c.userName">{{c.userName | limitTo(12)}} -
                    <span>
                    {{c.lastMessageDate | formatDayMonthHours}}
                    <svg v-if="!c.isread" style="position: absolute; top: 2px; right: -8px;" id="notification-chat" xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 6 6" fill="none" class="notification-point">
                      <circle cx="3" cy="3" r="3" fill="#FF445D"/>
                    </svg>
                    </span>
                </p>
                  <p v-bind:title="c.lastMessage"><span v-if="c.whoSentLastMessage === userInfo.id">Você: </span>{{c.lastMessage | limitTo(18)}}</p>
                </div>
              </div>
            </div>

            <!-- Messages Chat -->
            <div class="col-xs-12 col-sm-8 col-md-9 center-list-messages">
              <loading-page v-if="loadingChat" />

              <div v-if="!loadingChat" class="col-xs-12 col-sm-12 col-md-12">
                <div class="message-head">
                  <p>{{dataConversation.recipient.name}}</p>
                  <p><span v-if="dataConversation.recipient.team">{{dataConversation.recipient.team}} | {{dataConversation.recipient.office}} | {{dataConversation.recipient.email}}</span></p>
                </div>

                <div id="chatHistory" class="message-list custom-scrollbar">
                  <div v-for="a in dataConversation.chatList" class="col-xs-12 col-sm-12 col-md-12 list-chat">
                    <div class="content-chat" v-bind:class="(a.userId === userInfo.id) ? 'me-chat': 'user-chat'">
                      <h5 v-if="a.userId === userInfo.id" class="name">Você - <span>{{a.createdAt | formatDate}}</span></h5>
                      <h5 v-if="a.userId !== userInfo.id" class="name">{{dataConversation.recipient.name}} - <span>{{a.createdAt | formatDate}}</span></h5>
                      <p class="msg">{{a.text}}</p>
                    </div>
                  </div>
                </div>

                <div class="message-send">
                  <form @submit.prevent="sendMessage()">
                    <input v-model="messageSend" type="text" placeholder="Digite a sua mensagem...">

                    <button :disabled="loadingSend" v-bind:class="{'disable add-w-loading': loadingSend}" class="btn-point" type="submit">
                      <div v-if="loadingSend" class="loading-btn-login">
                        <div class="spinner-btn-yellow">
                          <div class="rect1"></div>
                          <div class="rect2"></div>
                          <div class="rect3"></div>
                          <div class="rect4"></div>
                          <div class="rect5"></div>
                        </div>
                      </div>
                      <i v-else class="fa fa-paper-plane" aria-hidden="true"></i>
                    </button>
                    <span class="txt-info1">Ao apertar enter, a mensagem será enviada.</span>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!listChat.length && failRequest" class="col-xs-12 col-sm-12 col-md-12 offset-top-30 box-empty">
            <img src="../../../..../../../assets/img/empty/internet.png" alt="internet" class="img-fluid img-responsive" />
            <p class="nunito">Tivemos um problema com a conexão, tente novamente atualizando a página.</p>
          </div>

          <div v-if="!listChat.length && !failRequest" class="col-xs-12 col-sm-12 col-md-12 box-empty text-center offset-top-60">
            <img src="../../../..../../../assets/img/empty/comunicados.png" alt="Comunicado" class="img-fluid" />
            <p class="nunito offset-top-30">Você ainda não possui nenhuma conversa até o momento.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>

  </section>
</template>

<script>
  import leftMenu from '../../components/leftMenu.vue';
  import createNewChat from "../../modals/createNewChat.vue";
  import loadingPage from '../../components/loadingPage.vue';
  import moment from 'moment';

  import { GET_LIS_CHAT, GET_DATA_CHAT, SEND_MESSAGE } from "../../../../urlConfig";
  import { REQUEST_SERVICE } from "../../../../requestConfig";
  import { UTIL_SERVICE } from "../../../../utils";
  import swal from "sweetalert";
  import vueFooter from "../../components/footer.vue";

  export default {
    name: 'chat',
    components: {
      vueFooter,
      leftMenu,
      createNewChat,
      loadingPage,
    },
    data() {
      return {
        callCheckList: '',
        openNewChat: '',
        userInfo: {},
        listChat: [],
        chatSelected: {
          index: null,
          data: {}
        },
        dataConversation: {
          recipient: {},
          chatList: []
        },
        messageSend: '',
        dataAtt: null,
        loading: false,
        haveAccess: false,
        loadingChat: false,
        loadingSend: false,
        failRequest: false
      }
    },
    methods: {
      openChat(data, index) {
        if (!this.loadingChat && data.id) {
          this.loadingChat = true;

          this.chatSelected.index = index;
          this.chatSelected.data = data;
          this.dataAtt = new Date();

          REQUEST_SERVICE.get(GET_DATA_CHAT + this.userInfo.companyId + "&conversationId=" + data.id).then((response) => {
            UTIL_SERVICE.console("RESULT GET_DATA_CHAT:", response.data);

            this.dataConversation.chatList = response.data.chatList.reverse();
            this.dataConversation.recipient = response.data.recipient;

            setTimeout(function(){
              $('#chatHistory').animate({scrollTop: 9999999}, 800);
            }, 200);

            this.loading = false;
            this.loadingChat = false;
          }).catch(reason => {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'openChat', {conversationId: data.id}, true, reason.response.data);

            this.loadingChat = false;
            this.failRequest = true;
          })
        }
      },
      getListChat() {
        this.loading = true;
        this.failRequest = false;

        REQUEST_SERVICE.get(GET_LIS_CHAT + this.userInfo.companyId).then((response) => {
            UTIL_SERVICE.console("RESULT GET_LIS_CHAT:", response.data);

            this.haveAccess = response.data.access;
            if (response.data.access) {
              this.listChat = response.data.result.list;
              this.dataAtt = new Date();

              if (response.data.result.list.length) {
                if (this.$route.params.idChat) {
                  response.data.result.list.map((value, index) => {
                    if (value.id === this.$route.params.idChat) {
                      this.openChat(value, index);
                    }
                  });
                } else {
                  this.openChat(response.data.result.list[0], 0);
                }
              } else {
                this.loading = false;
              }
            } else {
              this.loading = false;
            }

          }).catch(reason => {
          UTIL_SERVICE.historyLog(false, window.location.pathname, 'getListChat', {}, true, reason.response.data);

            this.loading = false;
            this.failRequest = true;
        })
      },
      sendMessage() {
        if (!this.loadingSend) {
          this.loadingSend = true;

          let obj = {
            whoSentId: this.userInfo.id,
            toWhoId: this.dataConversation.recipient.id,
            deviceId: JSON.parse(window.localStorage.getItem('browserId')),
            text: this.messageSend
          };

          if (this.chatSelected.data.id)
            obj.id = this.chatSelected.data.id;

          UTIL_SERVICE.console("DATA SEND:", obj);
          REQUEST_SERVICE.post(SEND_MESSAGE, obj).then((response) => {
            UTIL_SERVICE.console("RESULT SEND_MESSAGE:", response.data);

            if (response.data.id)
              this.chatSelected.data.id = response.data.id;

            this.dataConversation.chatList.push({
              createdAt: moment.utc(new Date()).format(),
              text: this.messageSend,
              userId: this.userInfo.id,
              isMe: true
            });

            this.listChat[this.chatSelected.index].lastMessage = this.messageSend;
            this.listChat[this.chatSelected.index].lastMessageDate = moment.utc(new Date()).format();
            this.listChat[this.chatSelected.index].whoSentLastMessage = this.userInfo.id;

            setTimeout(function(){
              $('#chatHistory').animate({scrollTop: 9999999}, 800);
            }, 200);

            this.messageSend = '';

            this.loadingSend = false;
          }).catch(reason => {
            UTIL_SERVICE.historyLog(false, window.location.pathname, 'sendMessage', obj, true, reason.response.data);
            this.loadingSend = false;

            reason.response.data.erros.map((value, index) => {
              swal("Aviso", value.value, "warning");
            });
          });
        }
      },
      openCreateChat() {
        this.callCheckList = Math.floor(Math.random() * 500);

        $("#createNewChat").modal();
      }
    },
    watch: {
      openNewChat: function (response) {
        if (response.resultCheck) {
          this.listChat.map((value, index) => {
            if (value.id === response.resultCheck.id) {
              this.openChat(value, index);
            }
          });
        } else {
          if (response.byList) {
            let haveChat = false;
            if (this.listChat.length) {
              this.listChat.map((value, index) => {
              if (value.userName === response.dataUser.name) {
                haveChat = true;

                this.openChat(value, index);
              }

              if (this.listChat.length === index + 1 && !haveChat) {
                this.listChat.unshift({
                  userId: response.dataUser.id,
                  photo: response.dataUser.photo,
                  userName: response.dataUser.name,
                  lastMessage: '',
                  whoSentLastMessage: this.userInfo.id,
                  lastMessageDate: '',
                  isread: true
                });

                this.chatSelected.data = {};
                this.chatSelected.index = 0;
                this.dataConversation = {};
                this.dataConversation.recipient = {
                  id: response.dataUser.id,
                  name: response.dataUser.name
                };
                this.dataConversation.chatList = [];
              }
            });
            } else {
              this.listChat.unshift({
                userId: response.dataUser.id,
                photo: response.dataUser.photo,
                userName: response.dataUser.name,
                lastMessage: '',
                whoSentLastMessage: this.userInfo.id,
                lastMessageDate: '',
                isread: true
              });

              this.chatSelected.data = {};
              this.chatSelected.index = 0;
              this.dataConversation = {};
              this.dataConversation.recipient = {
                id: response.dataUser.id,
                name: response.dataUser.name
              };
              this.dataConversation.chatList = [];
            }
          } else {
            this.listChat.unshift({
              userId: response.dataUser.id,
              photo: response.dataUser.photo,
              userName: response.dataUser.name,
              lastMessage: '',
              whoSentLastMessage: this.userInfo.id,
              lastMessageDate: '',
              isread: true
            });

            this.chatSelected.data = {};
            this.chatSelected.index = 0;
            this.dataConversation = {};
            this.dataConversation.recipient = {
              id: response.dataUser.id,
              name: response.dataUser.name
            };
            this.dataConversation.chatList = [];
          }
        }
      }
    },
    beforeMount() {
      this.userInfo = UTIL_SERVICE.getStorage('userInfo');

      this.getListChat();
    }
  }
</script>

<!-- Style from page -->
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/chat/chat.vue